import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store';

import userModel from '@/libs/userModel';

import NProgress from 'nprogress'; // 进度条
import 'nprogress/nprogress.css'; // 进度条样式

// 子系统配置文件
import AppModules from '@/modules-config';

// pages
import Layout from '@/pages/Layout.vue';
import NotFund from '@/pages/404.vue';
import Home from '@/pages/views/Home.vue';

// 子模块路由
import personal from './modules/personal';
import iframe from './modules/iframe';
import Event from '@/libs/Event';
import userCenterTemplate from './modules/user-center-template'; //授权管理

Vue.use(VueRouter);

// 修复重复push同个路由报错
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: {
      path: '/cooperation-manage/home',
    },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
        meta: {
          trust: true,
        },
      },
      {
        path: 'no-permision',
        name: 'NoPermision',
        component: () => import('@/pages/views/no-permision'),
        meta: {
          trust: true,
        },
      },
      userCenterTemplate,
      // 子模块页面
      personal,
      // 内嵌iframe
      iframe,
    ],
  },
  {
    path: '/404',
    component: NotFund,
    meta: {
      trust: true,
      noNeedLogin: true,
    },
  },
];

const router = new VueRouter({
  routes: routes,
});

const cachedModules = {};
router.beforeEach(async (to, from, next) => {

  let str=window.location.search.replace('?code=','')
  const [code,state]=str.split('&state=')
  if(code){
    history.replaceState(null,null,window.location.origin)
    to.query.code=code
  }
  // 用户登录状态拦截
  let loginStatus = await loginStatusInterceptors(to);
  if (!loginStatus) {
    return false;
  }
  if(state){
    const hashObjStr=localStorage.getItem('uuid-hash')
    const hashObj=JSON.parse(hashObjStr)||{}
    const hash=hashObj[state]||'#/cooperation-manage/home'
    console.log(hashObj);
    console.log(hash);
    localStorage.removeItem('uuid-hash')
    window.location.href=window.location.origin+'/'+hash

    return
  }
  NProgress.start();

  // 取路径中标识子工程前缀的部分, 例如 '/subapp/xxx/index' 其中xxx即路由唯一前缀
  const [, module] = to.path.split('/');
  const [, fromModule] = from.path.split('/');
  // 如果能匹配上前缀则加载相应子工程模块
  if (Reflect.has(AppModules, module)) {
    // 如果没有子工程配置信息, 则请求
    if (!Reflect.has(cachedModules, module)) {
      const { default: application } = await window.System.import(
        AppModules[module].js
      );
      if (application && application.routes) {
        // 动态添加子项目的 route-list (添加外壳)
        router.addRoutes([
          {
            path: '/',
            name: 'Layout',
            component: Layout,
            children: [application.routes] || [],
          },
        ]);
      }
      // if (application && application.beforeEach) {
      //   application.beforeEach(to, from, next);
      // }

      // 发布加载应用事件
      Event.emit('app-load', { name: AppModules[module].name, path: module });
      // 更新下 current appCode
      store.dispatch('updataAppCode', AppModules[module].appCode);
      try {
        // 切换用户token
        fromModule !== module &&
          await store.dispatch(
            'refreshTokenByClientId',
            AppModules[module].clientId || ''
          );
      } catch (_) {
        return false;
      }
      // 加缓存
      cachedModules[module] = application;
      NProgress.done();
      if (application && application.beforeEach) {
        application.beforeEach(to, from, next);
      }else{
        next(to.fullPath);
      }
    } else {
      // 如果已经加载过该子工程的模块，则不再加载，直接取缓存的routes
      NProgress.done();
      // 更新下 current appCode
      store.dispatch('updataAppCode', AppModules[module].appCode);
      try {
        // 切换用户token
        fromModule !== module &&
          await store.dispatch(
            'refreshTokenByClientId',
            AppModules[module].clientId || ''
          );
      } catch (_) {
        return false;
      }

      // 权限判断，如果子系统有checkPermission则调用子系统权限认证方法，如果没有直接放过
      if (cachedModules[module] && cachedModules[module].checkPermission) {
        cachedModules[module].checkPermission(to, from, next);
      } else {
        next();
      }
    }
    return false;
  }
  NProgress.done();
  if (to.matched.length) {
    next();
  } else {
    next('/404');
  }
});

async function loginStatusInterceptors(to) {
  // 判断是否登录，如果没有登录先行登录
  const isLogined = await userModel.checkLoginState();

  let loginStatus = true;

  // console.log('登录状态', isLogined);
  if (!isLogined && !to.meta.noNeedLogin) {
    try {
      // 拓展第三个参数，路由跳转地址
      await userModel.doLogin(to.query, null, to);
    } catch (e) {
      loginStatus = false;
    }
  }

  store.commit('UPDATE_LOGIN_STATE', isLogined);

  return loginStatus;
}
export default router;
